import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/layout';
import HomePage from './pages/home-page';
import RecrutementPage from './pages/entreprise/recrutement-page';
import CampagnesPage from './pages/entreprise/campagnes-page';
import ExternalisationPage from './pages/entreprise/externalisation-page';
import IAEntreprisePage from './pages/entreprise/ia-page';
import OffresPage from './pages/candidat/offres-page';
import PourquoiPage from './pages/candidat/pourquoi-page';
import CooptationPage from './pages/candidat/cooptation-page';
import TalentAIPage from './pages/candidat/talentai-page';
import QuestionsPage from './pages/infos/questions-page';
import ChartePage from './pages/infos/charte-page';
import TarifsPage from './pages/infos/tarifs-page';
import ContactPage from './pages/infos/contact-page';
import ArticlesPage from './pages/ressources/articles-page';
import ArticlePage from './pages/ressources/article-page';
import EditArticlePage from './pages/admin/edit-article';
import OutilsPage from './pages/ressources/outils-page';
import RessourcesPage from './pages/ressources/ressources-page';
import MappingRHPage from './pages/ressources/mapping-rh';
import MentionsLegalesPage from './pages/legal/mentions-legales-page';
import ConfidentialitePage from './pages/legal/confidentialite-page';
import CGVPage from './pages/legal/cgv-page';
import TimelineRecrutementPage from './pages/private/timeline-recrutement';
import TimelineCampagnesPage from './pages/private/timeline-campagnes';
import ForecastsPage from './pages/private/forecasts';
import NotFoundPage from './pages/not-found';
import { testConnection } from './lib/supabase';
import { useAuth } from './AuthProvider';
import toast from 'react-hot-toast';

function App() {
  const { loading: authLoading } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        const isConnected = await testConnection();
        if (!isConnected) {
          setError('Erreur de connexion à la base de données');
          return;
        }
        setIsInitialized(true);
      } catch (err) {
        console.error('Initialization error:', err);
        setError('Erreur d\'initialisation de l\'application');
        toast.error('Erreur d\'initialisation. Veuillez rafraîchir la page.');
      }
    };

    initialize();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-neutral-800 mb-4">
            Une erreur est survenue
          </h1>
          <p className="text-neutral-600 mb-6">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
          >
            Rafraîchir la page
          </button>
        </div>
      </div>
    );
  }

  if (!isInitialized || authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/entreprise/recrutement" element={<RecrutementPage />} />
      <Route path="/entreprise/campagnes" element={<CampagnesPage />} />
      <Route path="/entreprise/externalisation" element={<ExternalisationPage />} />
      <Route path="/entreprise/ia" element={<IAEntreprisePage />} />
      <Route path="/candidat/offres" element={<OffresPage />} />
      <Route path="/candidat/pourquoi" element={<PourquoiPage />} />
      <Route path="/candidat/cooptation" element={<CooptationPage />} />
      <Route path="/candidat/talentai" element={<TalentAIPage />} />
      <Route path="/infos/questions" element={<QuestionsPage />} />
      <Route path="/infos/charte" element={<ChartePage />} />
      <Route path="/infos/tarifs" element={<TarifsPage />} />
      <Route path="/infos/contact" element={<ContactPage />} />
      <Route path="/ressources/articles" element={<ArticlesPage />} />
      <Route path="/ressources/articles/:slug" element={<ArticlePage />} />
      <Route path="/ressources/articles/:slug/edit" element={<EditArticlePage />} />
      <Route path="/ressources/outils" element={<OutilsPage />} />
      <Route path="/ressources/ressources" element={<RessourcesPage />} />
      <Route path="/ressources/mapping-rh" element={<MappingRHPage />} />
      <Route path="/legal/mentions-legales" element={<MentionsLegalesPage />} />
      <Route path="/legal/confidentialite" element={<ConfidentialitePage />} />
      <Route path="/legal/cgv" element={<CGVPage />} />
      <Route path="/admin/timeline-recrutement" element={<TimelineRecrutementPage />} />
      <Route path="/admin/timeline-campagnes" element={<TimelineCampagnesPage />} />
      <Route path="/admin/forecasts" element={<ForecastsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;